module.exports = __webpack_public_path__ + "static/media/fast_forward_icon.f9a6cbbe.svg";